<template>
  <div class="white-container full-page-container common-table">
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="add">新增</el-button>
    <el-form class="search-bar" :inline="true" size="small">
      <el-form-item label="活动状态">
        <el-select ref="statusBox" v-model="search.status" placeholder="选择活动状态">
          <el-option label="全部" value="" />
          <el-option v-for="item in statusList" :key="item.id" :label="item.value" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item class="search-form-item">
        <el-input v-model="search.name" placeholder="输入你想搜索的文字" prefix-icon="el-icon-search" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchSubmit">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table ref="multipleTable" size="small" :data="list" style="width: 100%">
      <el-table-column prop="id" label="跑步活动ID" width="100" fixed />
      <el-table-column prop="name" label="活动标题" width="100" />
      <el-table-column prop="type" label="类型" width="100">
        <template v-slot="{row}">
          <span v-if="row.type === 0">跑步</span>
          <span v-else-if="row.type === 1">骑行</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="活动状态" align="center" width="auto" min-width="100">
        <template v-slot="{row}">
          <el-tag :type="statusList.find(item=>item.id == row.status).color" :class="row.status == 5 ? 'el-tag-blue' : row.status == 6 ? 'el-tag-purple':'' " size="mini">{{ statusList.find(item=>item.id == row.status).value || '--' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="beginTime" label="活动时间" width="auto" min-width="160">
        <template #default="{row}">
          {{ $moment(row.beginTime).format('YYYY/MM/DD')+'-'+$moment(row.endTime).format('YYYY/MM/DD') || '--' }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" width="460px" label="操作">
        <template v-slot="{row}">
          <el-button size="small" type="text" class="link-color" @click="edit(row)">编辑</el-button>
          <el-button size="small" type="text" class="link-color" @click="copyLink(row)">复制链接</el-button>
          <el-button size="small" type="text" class="link-color" @click="viewGraph(row)">查看轨迹图</el-button>
          <el-button size="small" type="text" class="link-color" @click="remove(row)">删除</el-button>
          <el-button v-if="row.status !== 0" size="small" type="text" class="link-color" @click="exportRunning(row)">{{ row.type === 0 ? '跑步记录' : '骑行记录' }}</el-button>
          <el-button v-if="row.status === 1" size="small" type="text" class="link-color" @click="release(row)">发布</el-button>
          <el-button v-if="row.status === 0" size="small" type="text" class="link-color" @click="postOfflineTask(row.id)">下架</el-button>
          <!-- <el-button v-if="row.status === 4" size="small" type="text" class="link-color" @click="runALottery(row)">开奖</el-button>
          <el-button v-if=" row.status === 5 || row.status === 6" size="small" type="text" class="link-color" @click="searchResult(row)">查看中奖记录</el-button>
          <el-button v-if="row.status === 5 && row.status !== 6" size="small" type="text" class="link-color" @click="showResult(row)">显示中奖公示</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background class="fixed-below" :page-size="currentPage.limit" :page-sizes="[10, 20, 50, 100]" :current-page.sync="currentPage.current" :total="currentPage.total" layout="total, prev, pager, next, sizes" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSucces" />
    <!-- 抽奖弹窗 -->
    <el-dialog v-if="importDialogShow" :visible="importDialogShow" title="开奖" custom-class="share-wrapper" @close="handleCloseImport">
      <div class="lottery-top" style="display:flex">
        <div>完成活动人数：{{ lotteryForm.taskCompleteNum }}</div>
        <div>抽奖总资格数：{{ lotteryForm.prizeNum }}</div>
      </div>
      <div class="lottery-box">
        <el-form ref="lotteryForm" class="lottery-form" :model="lotteryForm" :rules="lotteryFormRules" size="small">
          <el-form-item prop="prizeInformationListVOS">
            <template v-for="(item, index) in lotteryForm.prizeInformationListVOS">
              <div :key="index" class="prizeBox">
                <span>奖品{{ index+1 }}：</span>
                <span class="prizeName">{{ item.prizeName }}</span>
                <span>奖品数量：{{ item.prizeNum }}</span>
              </div>
            </template>
          </el-form-item>
          <el-form-item label="有效期" prop="exportTime">
            <el-date-picker v-model="lotteryForm.exportTime" type="datetimerange" range-separator="-" start-placeholder="兑奖开始日期和时间" end-placeholder="兑奖结束日期和时间" class="lottery-time" prefix-icon="el-icon-date" value-format="yyyy-MM-dd HH:mm:ss" @change="handleFormatExportTime" />
          </el-form-item>
        </el-form>
      </div>
      <div class="flex btns">
        <el-button type="info" @click="handleCloseImport">取消</el-button>
        <el-button type="primary" class="submitBtn" @click="uploadSubmit">确认开奖</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Dialog from '@/components/Dialog';
import { formatDateTime } from '@/filters';
export default {
  components: { Dialog },
  data() {
    const statusList = [
      { id: 0, value: '已发布', color: 'success' },
      { id: 1, value: '草稿', color: 'warning' }, // 未发布
      { id: 2, value: '已结束', color: 'info' },
      { id: 3, value: '进行中', color: 'danger' }, // 可报名
      { id: 4, value: '未开奖', color: 'danger' },
      { id: 5, value: '已开奖' },
      { id: 6, value: '已公示' },
    ];
    return {
      statusList,
      search: {
        name: "",
        status: "",
      },
      list: [],
      currentPage: {
        current: 1,
        limit: 10,
        total: 0,
      },
      currentID: -1,
      formDialogShow: false,
      information: {},
      importDialogShow: false,
      lotteryForm: {},
      lotteryFormRules: {
        exportTime: [
          { type: 'array', required: true, message: '请选择活动时间', trigger: ['change', 'blur'] },
        ],
      },
    };
  },
  computed: {
  },
  created() {
    this.getList();
  },
  methods: {
    searchSubmit() {
      this.getList();
    },
    reset() {
      this.search = {
        name: '',
        status: '',
      };
      this.currentPage.current = 1;
      this.getList();
    },
    getList() {
      this.$Api.running.postRunningActivity({ ...this.search, ...this.currentPage }).then(res => {
        if (res) {
          this.list = res.data;
          this.currentPage.total = res.total;
        }
      });
    },
    edit(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      if (row.status === 5 || row.status === 6) {
        this.isRunALottery = true;
      }
      this.information = {
        operation: 'edit',
        icon: 'warn',
        subTitle: `是否确认编辑活动ID为“${row.id}”的数据项？`,
      };
    },
    exportRunning(row) {
      const _this = this;
      this.$Api.running.exportRunningActivity(row.id).then(res => {
        _this.$message.success('下载成功');
        _this.getList();
      });
    },
    copyLink(row) {
      // 跑步活动小程序路径
      let page = `/pages/stroll/index?id=`;
      if (!row.id) return;
      page += row.id;
      navigator.clipboard.writeText(page).then(() => {
        this.$message.success('复制成功');
      }).catch(() => {
        this.$message.error('复制失败');
      });
    },
    viewGraph(row) {
      this.$router.push({ path: '/online_activity/running/graph', query: { id: row.id } });
    },
    remove(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: '活动一旦删除，不可恢复，请确认删除活动',
      };
    },
    release(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'release',
        icon: 'warn',
        subTitle: `是否确认发布活动ID为“${this.currentID}”的数据项？`,
      };
    },
    postOfflineTask(id) {
      this.formDialogShow = true;
      this.currentID = id;
      this.information = {
        operation: 'offline',
        icon: 'warn',
        subTitle: `是否确认下架活动ID为“${this.currentID}”的数据项？`,
      };
    },
    showResult(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'show',
        icon: 'warn',
        subTitle: `是否确认在小程序前端公示【${row.name}】活动开奖结果？`,
      };
    },
    searchResult(row) {
      const _this = this;
      this.$Api.challengeMatch.lotteryDownload({ objectType: 15, objectId: row.id }).then(res => {
        _this.$message.success('下载成功');
        _this.getList();
      });
    },
    submitSucces(operation) {
      if (operation === 'delete') {
        this.$Api.running.delRunningActivity(this.currentID).then(() => {
          this.formDialogShow = false;
          this.$message.success('删除成功');
          this.getList();
        }).catch(error => {
          this.formDialogShow = true;
          this.information = {
            operation: 'error',
            icon: 'error',
            subTitle: `${error.errorMessage}`,
          };
        });
      } else if (operation === 'edit') {
        this.$router.push({ path: `/online_activity/running/edit`, query: { id: this.currentID, lottery: this.isRunALottery } });
      } else if (operation === 'show') {
        this.$Api.running.runningShowLottery(this.currentID).then(() => {
          this.getList();
          this.formDialogShow = false;
        }).catch(error => {
          this.formDialogShow = true;
          this.information = {
            operation: 'error',
            icon: 'error',
            subTitle: `${error.errorMessage}`,
          };
        });
      } else if (operation === 'release') {
        this.$Api.running.releaseRunningActivity(this.currentID).then(() => {
          this.$message.success('发布成功');
          this.getList();
        });
      } else if (operation === 'offline') {
        this.$Api.running.offlineRunningActivity(this.currentID).then(() => {
          this.$message.success('下架成功');
          this.getList();
        });
      }
    },
    runALottery(row) {
      this.importDialogShow = true;
      this.lotteryForm = row;
    },
    handleCloseImport() {
      this.lotteryForm = {};
      this.importDialogShow = false;
    },
    // 处理导出时间
    handleFormatExportTime(val) {
      this.exportTimes = {
        prizeBeginTime: '',
        prizeEndTime: '',
      };
      if (val && val.length) {
        this.exportTimes = {
          prizeBeginTime: formatDateTime(val[0]),
          prizeEndTime: formatDateTime(val[1]),
        };
      }
    },
    uploadSubmit() {
      // 确认开奖
      const { id, taskCompleteNum } = this.lotteryForm;
      const _this = this;
      _this.$refs.lotteryForm.validate(valid => {
        if (valid) {
          if (taskCompleteNum === '0') {
            return _this.$message.error('没有人完成活动不可抽奖');
          }
          _this.$Api.challengeMatch.lotteryUserLottery({ ..._this.exportTimes, objectType: 15, objectId: id }).then(res => {
            _this.$message.success('抽奖成功');
            this.getList();
          });
          _this.handleCloseImport();
        } else {
          return false;
        }
      });
    },
    add() {
      this.$router.push({ path: '/online_activity/running/add' });
    },
    handleSizeChange(value) {
      this.currentPage.limit = value;
      this.getList();
    },
    handleCurrentChange(value) {
      this.currentPage.current = value;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.el-dialog__wrapper {
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  /deep/ .share-wrapper {
    width: 580px;
    margin: unset !important;
    .el-dialog__header {
      height: 6.85vh !important;
      line-height: 6.85vh;
      padding: 0 2.87vh 0 2.78vh !important;
      background: #000000 !important;
      box-sizing: border-box !important;
      .el-dialog__title {
        font-family: "Noto Sans SC";
        font-style: normal;
        font-weight: 500;
        font-size: 1.48vh;
        color: #ffffff;
      }
      .el-dialog__headerbtn {
        top: 2.87vh;
        right: 2.87vh;
        font-size: 1.11vh;
        .el-dialog__close {
          color: #ffffff;
          &:hover {
            color: #dc0019;
          }
        }
      }
    }
    .el-dialog__body {
      padding: 20px 30px 30px;
      .upload-wrap {
        width: 100%;
        height: 236px;
        background: #f7f7f7;
        border: 1px dashed #bbbbbb;
        border-radius: 4px;
        padding: 20px 30px;
        box-sizing: border-box;
        .el-upload-dragger {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .tips {
          font-family: "Noto Sans SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #494949;
          margin-bottom: 20px;
        }
        .upload-box {
          width: 100%;
          height: 156px;

          .el-upload.el-upload--text {
            width: 100%;
            height: 100%;
            .el-upload-dragger {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              border: 1px solid #bbbbbb;
              border-radius: 4px;
              &:hover {
                border-color: #1c1c1c;
              }
              .file {
                line-height: 20px;
                margin-top: 5.68px;
              }
              .el-button {
                margin-top: 10px;
              }
            }
          }
        }
      }
    }
    .btns {
      justify-content: center;
      margin-top: 30px;
      .el-button {
        width: 120px;
        height: 50px;
      }
      .el-button + .el-button {
        margin-left: 30px;
      }
    }
  }
}

.lottery-form {
  .el-form-item {
    margin-bottom: 0;
  }
}

.lottery-top {
  width: 100%;
  height: 23px;
  display: flex;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  margin-bottom: 20px;
  div {
    margin-right: 50px;
  }
}

.lottery-time {
  width: 370px !important;
}

.prizeBox {
  position: relative;
  display: flex;
  width: 100%;

  :last-child {
    position: absolute;
    left: 0;
    margin-left: 170px;
  }
  .prizeName {
    max-width: 110px;
  }

  > span {
    display: inline-block;
    margin-bottom: 20px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #494949;
  }
}

.el-tag-blue {
  background-color: rgba(24, 144, 255, 0.1);
  border-color: rgba(24, 144, 255, 0.7);
  color: #1890ff;
}

.el-tag-purple {
  background-color: rgba(114, 46, 209, 0.1);
  border-color: rgba(114, 46, 209, 0.7);
  color: #722ed1;
}
</style>
